import { RelatedEntity } from './related-entity.model';
import { ReportEntity } from './report-entity.model';
import { Provider } from '../../provider/provider.model';
import { ObjectModel } from 'rte-core-app';

export class Report {
    Id?: number;
    Name = '';
    Description = '';
    Query: string;
    QueryDetail: string;
    Scale = 1;
    ObjectId: number;
    SystemReport: boolean;
    MenuSystem: string;
    SubMenuSystem: string;
    Provider: Provider = new Provider();
    RelatedEntities: Array<RelatedEntity> = [];
    Entities: Array<ReportEntity> = [];
    Revision: number;
}
